import { useKeycloak } from "@react-keycloak/web";
import { CityInput } from "../components/CityInput/CityInput";
import styled, { css } from "styled-components/macro";

const Secured = () => {
  const { keycloak } = useKeycloak();
  if (keycloak) {
    if (keycloak.authenticated)
      return (
        <div className="page">
          <p>
            This is a Keycloak-secured component of your application. You
            shouldn't be able to see this unless you've authenticated with
            Keycloak.
          </p>
          {!!keycloak.tokenParsed && keycloak.tokenParsed.preferred_username}
          <StyledCityInput
            id={"cityInput"}
            placeholder={""}
            title={"City Input"}
            value={null}
            errorMessage={""}></StyledCityInput>
        </div>
      );
    else return <div className="page">Unable to authenticate!</div>;
  }

  return <div>Initializing Keycloak...</div>;
};

export const InputStyle = css`
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 2.4rem;
  width: 300px;
`;

const StyledCityInput = styled(CityInput)`
  & input {
    ${InputStyle}
  }
` as typeof CityInput; // we need to do this as styled components doesn't return the generic type

export default Secured;
